import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4e99d6b7&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=4e99d6b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e99d6b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e99d6b7')) {
      api.createRecord('4e99d6b7', component.options)
    } else {
      api.reload('4e99d6b7', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4e99d6b7&scoped=true", function () {
      api.rerender('4e99d6b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/List.vue"
export default component.exports